const pageNameKey = "patchTicketPriorityDropdown";

export const patchTicketPriorityDropdownEn = {
  [pageNameKey]: {
    labelLow: "Low",
    labelNormal: "Normal",
    labelHigh: "High",
    labelUrgent: "Urgent",
    errorUpdatingPriority: "It was not possible to update the ticket priority.",
    selectPriorityLabel: "Select priority",
    successUpdatingPriority: "Ticket priority updated successfully.",
  },
};

export const patchTicketPriorityDropdownPtBr = {
  [pageNameKey]: {
    labelLow: "Baixo",
    labelNormal: "Normal",
    labelHigh: "Alto",
    labelUrgent: "Urgente",
    errorUpdatingPriority: "Não foi possível atualizar a prioridade do ticket.",
    selectPriorityLabel: "Selecionar prioridade",
    successUpdatingPriority: "Prioridade do ticket atualizada com sucesso.",
  },
};

export const patchTicketPriorityDropdownDe = {
  [pageNameKey]: {
    labelLow: "Niedrig",
    labelNormal: "Normal",
    labelHigh: "Hoch",
    labelUrgent: "Dringend",
    errorUpdatingPriority:
      "Es war nicht möglich, die Priorität des Tickets zu aktualisieren.",
    selectPriorityLabel: "Priorität auswählen",
    successUpdatingPriority: "Priorität des Tickets erfolgreich aktualisiert.",
  },
};

export const patchTicketPriorityDropdownZhHans = {
  [pageNameKey]: {
    labelLow: "低",
    labelNormal: "正常",
    labelHigh: "高",
    labelUrgent: "紧急",
    errorUpdatingPriority: "无法更新工单优先级。",
    selectPriorityLabel: "选择优先级",
    successUpdatingPriority: "工单优先级更新成功。",
  },
};

export const patchTicketPriorityDropdownIt = {
  [pageNameKey]: {
    labelLow: "Basso",
    labelNormal: "Normale",
    labelHigh: "Alto",
    labelUrgent: "Urgente",
    errorUpdatingPriority:
      "Non è stato possibile aggiornare la priorità del ticket.",
    selectPriorityLabel: "Scegli priorità",
    successUpdatingPriority:
      "La priorità del ticket è stata aggiornata con successo.",
  },
};

export const patchTicketPriorityDropdownEs = {
  [pageNameKey]: {
    labelLow: "Bajo",
    labelNormal: "Normal",
    labelHigh: "Alto",
    labelUrgent: "Urgente",
    errorUpdatingPriority: "No fue posible actualizar la prioridad del ticket.",
    selectPriorityLabel: "Selecciona la prioridad",
    successUpdatingPriority:
      "La prioridad del ticket se actualizó correctamente.",
  },
};

export const patchTicketPriorityDropdownNl = {
  [pageNameKey]: {
    errorUpdatingPriority:
      "Het was niet mogelijk om de prioriteit van het ticket bij te werken.",
    labelHigh: "Hoog",
    labelLow: "Laag",
    labelNormal: "Normaal",
    labelUrgent: "Dringend",
    selectPriorityLabel: "Prioriteit selecteren",
    successUpdatingPriority: "Ticketprioriteit succesvol bijgewerkt.",
  },
};

export const patchTicketPriorityDropdownTr = {
  [pageNameKey]: {
    errorUpdatingPriority: "Bilet önceliğini güncellemek mümkün olmadı.",
    labelHigh: "Yüksek",
    labelLow: "Düşük",
    labelNormal: "Normal",
    labelUrgent: "Acil",
    selectPriorityLabel: "Öncelik seçin",
    successUpdatingPriority: "Bilet önceliği başarıyla güncellendi.",
  },
};
